import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormHelperText } from '@material-ui/core';
import { SketchPicker } from 'react-color';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions'
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';
import RichTextEditor from 'react-rte';
import _ from 'lodash';
import ContentLabelForm from '../content_label/ContentLabelForm';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '30%',
        textAlign: 'right'
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    insidePaper: {
        padding: '10px'
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
    customInput: {
        color: 'blue',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});


class CourseForm extends Component {
    state = {
        unscheduledDialog: false,
        rte_value: RichTextEditor.createValueFromString(this.props.course.CourseEnrollmentDescription, 'html')
        // rte_value: RichTextEditor.createEmptyValue()
    }

    handleTabChange = (event, value) => {
        this.setState({ majorTabValue: value });
    };

    handleChange = field_name => event => {
        let value = ''

        if (field_name === 'app_qualification_id') {
            if (event.target.value === 0) {
                this.props.updateCourseForm({ app_role_id: 0 });
                const validator = {
                    field_name: 'app_role_id', value: 1
                }
                this.props.updateCourseForm({ app_qualification_id: 0 })
                return this.props.runValidator(validator)
            }
            else {
                this.props.updateCourseForm({ app_role_id: 0 });
                const validator = {
                    field_name: 'app_role_id', value: this.props.course.app_role_id
                }
                this.props.updateCourseForm({ app_qualification_id: event.target.value })
                return this.props.runValidator(validator)
            }
        }

        if (field_name === 'Color') {
            value = event.hex
        }
        else {
            value = event.target.value;
            if (event.target.type === 'checkbox') {
                value = event.target.checked ? 1 : 0;
            }
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateCourseForm(update_data);
    }

    handleBlur = (field_name) => (event) => {
        const { updateCourseForm } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));
        }

        const update_data = {
            [field_name]: new_value
        }
        updateCourseForm(update_data);
    }

    handleQualificationChange = field_name => event => {
        let value = event.target.value;

        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }
        const update_data = {
            [field_name]: value
        }
        this.props.updateCourseQualificationForm(update_data)
    }

    handleIntroCourseUpdate = field_name => event => {
        let value = event.target.value;

        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }
        const update_data = {
            [field_name]: value
        }
        this.props.updateCourseIntro(update_data)
    }


    handleUnscheduled = () => {
        this.props.clearSchedule();
        this.setState({ unscheduledDialog: false });
        return true;
    }

    handleQualificationBlur = (field_name) => (event) => {
        const { updateCourseQualificationForm } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));
        }

        const update_data = {
            [field_name]: new_value
        }
        updateCourseQualificationForm(update_data);
    }

    handleCopyClick = () => {
        this.props.toggleCourseRepull(true)
        return this.props.history.push('/course/edit/' + this.props.copiedCourse.course_id)
    }

    render() {
        const {
            classes,
            view_type,
            theme,
            course,
            validator,
            apps
        } = this.props;

        const qualFields = (active) => {
            if (active) {

                const qualItems = this.props.allQualifications.map(q => {
                    return (
                        <MenuItem key={q.qualification_id} value={q.qualification_id}><span>{q.QualificationName}</span></MenuItem>
                    )
                });
                return (
                    <div>
                        <FormControl variant="outlined">
                            <InputLabel
                                ref={ref => {
                                    this.InputLabelRef = ref;
                                }}
                                htmlFor="outlined-age-simple"
                                style={{ marginLeft: '5px' }}
                            >
                                Qualification
                            </InputLabel>
                            <Select
                                style={{ minWidth: '50px', marginLeft: '8px' }}
                                value={course.qualification.qualification_id}
                                onChange={this.handleQualificationChange('qualification_id')}
                                input={
                                    <OutlinedInput
                                        labelWidth={85}
                                        name="Qual"
                                        id="outlined-age-simple"
                                    />
                                }
                            >
                                <MenuItem value={0}>
                                    <em>None</em>
                                </MenuItem>
                                {qualItems}
                            </Select>
                        </FormControl>
                        <Grid item xs={12}>
                            <TextField
                                id="Days"
                                label="Days"
                                className={classes.textField}
                                value={course.qualification.Days}
                                margin="normal"
                                variant="outlined"
                                disabled={view_type === 'detail'}
                                onChange={this.handleQualificationChange('Days')}
                                onBlur={this.handleQualificationBlur('Days')}
                                type='number'
                                inputProps={{
                                    min: 0,
                                    step: 1
                                }}
                            />
                        </Grid>
                    </div>
                )
            }
            return null
        }

        const unscheduledDialog =
            <Dialog
                open={this.state.unscheduledDialog}
                // open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Schedule Toggle"}</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span>Warning: this will cause the course's schedule to be emptied</span><br></br><br></br>
                        <Button onClick={() => this.handleUnscheduled()} variant={'contained'}>Change</Button>
                        <Button style={{ float: 'right' }} onClick={() => this.setState({ unscheduledDialog: false })} variant={'contained'}>Back</Button>
                    </DialogContentText>
                </DialogContent>
            </Dialog >

        return (
            <Grid container spacing={8}>
                {unscheduledDialog}
                <Grid item xs={5}>
                    <form style={styles.insidePaper} className={classes.container} noValidate autoComplete="off">
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="CourseName"
                                label="Course Name"
                                value={course.CourseName}
                                onChange={this.handleChange('CourseName')}
                                error={validator.filter(v => v.field_name === 'CourseName')[0].error}
                                helperText={validator.filter(v => v.field_name === 'CourseName')[0].error_msg}
                                {...getSharedTextFieldProps(view_type, classes)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="CourseDescription"
                                label="Course Description"
                                value={course.CourseDescription}
                                onChange={this.handleChange('CourseDescription')}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={(course.CourseDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="CourseSizeLimit"
                                label="Course Size Limit"
                                value={course.CourseSizeLimit}
                                onBlur={this.handleBlur('CourseSizeLimit')}
                                onChange={this.handleChange('CourseSizeLimit')}
                                type='number'
                                inputProps={{
                                    min: 0.00,
                                    step: 1
                                }}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={classes.numberField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '6px' }}
                                        checked={(course.Unscheduled === 1 || course.Unscheduled === true)}
                                        onChange={() => this.setState({ unscheduledDialog: true })}
                                        color="primary"
                                    />
                                }
                                label="Unscheduled"
                                disabled={view_type === 'detail'}
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '6px' }}
                                        checked={(course.Active === 1 || course.Active === true)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                        disableRipple={view_type === 'detail'}
                                        value="Active"
                                        color="primary"
                                    />
                                }
                                label="Active"
                            />
                        </Grid> */}
                        

                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel
                                    ref={ref => {
                                        this.InputLabelRef = ref;
                                    }}
                                    htmlFor="outlined-age-simple"
                                    style={{ marginLeft: '5px' }}
                                >
                                    Qualification for App
                                </InputLabel>
                                <Select
                                    style={{ minWidth: '250px', marginLeft: '8px' }}
                                    value={course.app_qualification_id}
                                    onChange={this.handleChange('app_qualification_id')}
                                    input={
                                        <OutlinedInput
                                            labelWidth={140}
                                            name="App"
                                            id="outlined-age-simple"
                                        />
                                    }
                                >
                                    <MenuItem value={0}>
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={1}>
                                        <span>Pharmacy</span>
                                    </MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} style={{ paddingTop: '20px' }}>
                            {course.app_qualification_id !== 0 ?
                                <FormControl variant="outlined" className={classes.formControl} error={validator.filter(v => v.field_name === 'app_role_id')[0].error}>
                                    <InputLabel
                                        ref={ref => {
                                            this.InputLabelRef = ref;
                                        }}
                                        htmlFor="outlined-age-simple"
                                        style={{ marginLeft: '5px' }}
                                    >
                                        Role
                                    </InputLabel>
                                    <Select
                                        style={{ minWidth: '250px', marginLeft: '8px' }}
                                        value={course.app_role_id}
                                        onChange={this.handleChange('app_role_id')}
                                        // error={validator.filter(v => v.field_name === 'app_role_id')[0].error}
                                        // helperText={validator.filter(v => v.field_name === 'app_role_id')[0].error_msg}
                                        input={
                                            <OutlinedInput
                                                labelWidth={30}
                                                name="Role"
                                                id="outlined-age-simple"
                                            />
                                        }
                                    >
                                        <MenuItem value={0}>
                                            <em>None</em>
                                        </MenuItem>
                                        {apps.find((app) => app.app_id === course.app_qualification_id).roles.map((role) => {
                                            return (
                                                <MenuItem key={role.role_id} value={role.role_id}>
                                                    <span>{role.displayName}</span>
                                                </MenuItem>
                                            )
                                        })}

                                    </Select>
                                    <FormHelperText>
                                        {validator.filter(v => v.field_name === 'app_role_id')[0].error
                                            ? validator.filter(v => v.field_name === 'app_role_id')[0].error_msg
                                            : " "}
                                    </FormHelperText>
                                </FormControl> :
                                null
                            }

                        </Grid>

                        <Grid item xs={12} style={{ paddingTop: '20px' }}>
                            <ContentLabelForm
                                labelList={this.props.contentLabelList}
                                component_reference={'course'}
                                component_reference_id={course.course_id}
                                baseComponent={course}
                                updateFunction={this.props.updateCourseForm}
                                view_type={view_type}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            {view_type === 'detail' ?
                                <div>
                                    <div style={{ float: 'left', paddingTop: '7px' }}>Color:</div>
                                    <div style={{ float: 'right', width: '30px', height: '30px', borderRadius: '50%', background: course.Color }} ></div>
                                </div>
                                :
                                null
                            }

                        </Grid>

                    </form>

                </Grid>
                <Grid item xs={3}>
                    <ComponentTrackingInfo
                        editInfo={this.props.editInfo}
                        view_type={this.props.view_type}
                        classes={classes}
                    />
                    {this.props.copiedCourse ?
                        <TextField
                            id="Copied Course Name"
                            label="Copied Course Name"
                            value={this.props.copiedCourse.CourseName}

                            inputProps={{ className: classes.customInput, onClick: () => this.handleCopyClick() }}
                            {...getSharedTextFieldProps('detail', classes)}
                        />
                        :
                        null
                    }
                </Grid>
                <Grid item xs={4}>
                    {view_type === 'detail' ? null :
                        <SketchPicker
                            color={course.Color}
                            onChangeComplete={this.handleChange('Color')}
                            disableAlpha={true}
                        />
                    }
                </Grid>
            </Grid>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourse: Actions.getCourse,
        deleteCourse: Actions.deleteCourse,
        updateCourseForm: Actions.updateCourseForm,
        toggleMajor: Actions.toggleMajor,
        toggleModule: Actions.toggleModule,
        toggleInstructor: Actions.toggleInstructor,
        runValidator: validatorActions.runValidator,
        updateCourseQualificationForm: Actions.updateCourseQualificationForm,
        updateCourseIntro: Actions.updateCourseIntro,
        clearSchedule: Actions.clearSchedule,
        toggleCourseRepull: Actions.toggleCourseRepull,
    }, dispatch);
}

function mapStateToProps({ courseApp, auth, validator, contentLabelReducer }) {
    return {
        course: courseApp.courses.currentCourse,
        isCourseLoaded: courseApp.courses.isCourseLoaded,
        editInfo: courseApp.courses.editInfo,
        contentLabelList: contentLabelReducer.contentLabelReducer.contentLabelList,
        auth,
        validator: validator.list,
        allQualifications: courseApp.courses.allQualifications,
        apps: courseApp.courses.apps,
        copiedCourse: courseApp.courses.copiedCourse,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseForm)));



// WEBPACK FOOTER //
// src/main/content/course/CourseForm.js